import CroustilleElement from '../lib/CroustilleElement'
import isColliding from '../lib/isColliding'
import debounce from 'lodash/debounce'

const DEBUG = false
const SCROLL_THRESHOLD = 200 // px

class Header extends CroustilleElement {
  constructor() {
    super('header')
  }

  checkColliders(colliders, elements) {
    let collisions = []

    // DEBUG && console.clear()

    colliders.forEach(entry => {
      let items = []

      elements.forEach(e => {
        DEBUG && console.log(entry.id, isColliding(e, entry, true))

        if (isColliding(e, entry)) {
          if (!entry.dataset.name) {
            console.error('No name attribute is set on', entry)
          }
          if (!e.dataset.name) {
            console.error('No name attribute is set on', e)
          }

          items.push([e, entry.dataset.name])
        }
      })

      collisions = [...collisions, ...items]
    })

    return [...new Set(collisions)]
  }

  updateElements(elements, collisions) {
    elements.forEach(el => (el.dataset.colliding = 'false'))

    elements.forEach(el => {
      collisions.forEach(collision => {
        if (collision[0] === el && collision[1] === el.dataset.name) {
          el.dataset.colliding = 'true'
        }
      })
    })
  }

  onScroll() {
    const collisions = this.checkColliders(
      this.children('detect-collision', document),
      this.elements
    )

    // pour l'instant inutile
    if (collisions.length >= 0) {
      window.requestAnimationFrame(() =>
        this.updateElements(this.elements, collisions)
      )
    }

    // toggle data attr on node, passed a certain threshold
    if (this.node.dataset.checkScroll !== 'false') {
      if (
        this.node.dataset.scrollThreshold !== 'true' &&
        window.scrollY >= SCROLL_THRESHOLD
      ) {
        window.requestAnimationFrame(
          () => (this.node.dataset.scrollThreshold = 'true')
        )
      } else if (
        this.node.dataset.scrollThreshold !== 'false' &&
        window.scrollY < SCROLL_THRESHOLD
      ) {
        window.requestAnimationFrame(
          () => (this.node.dataset.scrollThreshold = 'false')
        )
      }
    }
  }

  init() {
    this.elements = this.children('element')
    this.debouncedOnScroll = debounce(this.onScroll, DEBUG ? 1000 : 10).bind(
      this
    )
    window.addEventListener('scroll', this.debouncedOnScroll)
    this.onScroll()
  }

  destroy() {
    window.removeEventListener('scroll', this.debouncedOnScroll)
  }
}

export default Header
